const subscriptionsTypes = {
    // Get subscriptions list
    GET_SUBSCRIPTIONS_PENDING: "GET_SUBSCRIPTIONS_PENDING",
    GET_SUBSCRIPTIONS_SUCCESS: "GET_SUBSCRIPTIONS_SUCCESS",
    GET_SUBSCRIPTIONS_ERROR: "GET_SUBSCRIPTIONS_ERROR",

    // Create subscription
    CREATE_SUBSCRIPTION_PENDING: "CREATE_SUBSCRIPTION_PENDING",
    CREATE_SUBSCRIPTION_SUCCESS: "CREATE_SUBSCRIPTION_SUCCESS",
    CREATE_SUBSCRIPTION_ERROR: "CREATE_SUBSCRIPTION_ERROR",

    // Get subscription details
    GET_SUBSCRIPTION_DETAILS_PENDING: "GET_SUBSCRIPTION_DETAILS_PENDING",
    GET_SUBSCRIPTION_DETAILS_SUCCESS: "GET_SUBSCRIPTION_DETAILS_SUCCESS",
    GET_SUBSCRIPTION_DETAILS_ERROR: "GET_SUBSCRIPTION_DETAILS_ERROR",

    // Update subscription
    UPDATE_SUBSCRIPTION_PENDING: "UPDATE_SUBSCRIPTION_PENDING",
    UPDATE_SUBSCRIPTION_SUCCESS: "UPDATE_SUBSCRIPTION_SUCCESS",
    UPDATE_SUBSCRIPTION_ERROR: "UPDATE_SUBSCRIPTION_ERROR",

    // Delete subscription
    DELETE_SUBSCRIPTION_PENDING: "DELETE_SUBSCRIPTION_PENDING",
    DELETE_SUBSCRIPTION_SUCCESS: "DELETE_SUBSCRIPTION_SUCCESS",
    DELETE_SUBSCRIPTION_ERROR: "DELETE_SUBSCRIPTION_ERROR",

    // Activate subscription
    ACTIVATE_SUBSCRIPTION_PENDING: "ACTIVATE_SUBSCRIPTION_PENDING",
    ACTIVATE_SUBSCRIPTION_SUCCESS: "ACTIVATE_SUBSCRIPTION_SUCCESS",
    ACTIVATE_SUBSCRIPTION_ERROR: "ACTIVATE_SUBSCRIPTION_ERROR",

    // Suspend subscription
    SUSPEND_SUBSCRIPTION_PENDING: "SUSPEND_SUBSCRIPTION_PENDING",
    SUSPEND_SUBSCRIPTION_SUCCESS: "SUSPEND_SUBSCRIPTION_SUCCESS",
    SUSPEND_SUBSCRIPTION_ERROR: "SUSPEND_SUBSCRIPTION_ERROR",

    // Use stamps
    USE_STAMPS_PENDING: "USE_STAMPS_PENDING",
    USE_STAMPS_SUCCESS: "USE_STAMPS_SUCCESS",
    USE_STAMPS_ERROR: "USE_STAMPS_ERROR",

    // Get user subscriptions (for transactions modal)
    GET_USER_SUBSCRIPTIONS_PENDING: "GET_USER_SUBSCRIPTIONS_PENDING",
    GET_USER_SUBSCRIPTIONS_SUCCESS: "GET_USER_SUBSCRIPTIONS_SUCCESS",
    GET_USER_SUBSCRIPTIONS_ERROR: "GET_USER_SUBSCRIPTIONS_ERROR",

    // Get analytics
    GET_SUBSCRIPTION_ANALYTICS_PENDING: "GET_SUBSCRIPTION_ANALYTICS_PENDING",
    GET_SUBSCRIPTION_ANALYTICS_SUCCESS: "GET_SUBSCRIPTION_ANALYTICS_SUCCESS",
    GET_SUBSCRIPTION_ANALYTICS_ERROR: "GET_SUBSCRIPTION_ANALYTICS_ERROR",

    // Get purchase history
    GET_PURCHASE_HISTORY_PENDING: "GET_PURCHASE_HISTORY_PENDING",
    GET_PURCHASE_HISTORY_SUCCESS: "GET_PURCHASE_HISTORY_SUCCESS",
    GET_PURCHASE_HISTORY_ERROR: "GET_PURCHASE_HISTORY_ERROR",

    // Get stamp usage history
    GET_STAMP_USAGE_HISTORY_PENDING: "GET_STAMP_USAGE_HISTORY_PENDING",
    GET_STAMP_USAGE_HISTORY_SUCCESS: "GET_STAMP_USAGE_HISTORY_SUCCESS",
    GET_STAMP_USAGE_HISTORY_ERROR: "GET_STAMP_USAGE_HISTORY_ERROR",

    // Get subscription clients
    GET_SUBSCRIPTION_CLIENTS_PENDING: "GET_SUBSCRIPTION_CLIENTS_PENDING",
    GET_SUBSCRIPTION_CLIENTS_SUCCESS: "GET_SUBSCRIPTION_CLIENTS_SUCCESS",
    GET_SUBSCRIPTION_CLIENTS_ERROR: "GET_SUBSCRIPTION_CLIENTS_ERROR",

    // Clear current subscription
    CLEAR_CURRENT_SUBSCRIPTION: "CLEAR_CURRENT_SUBSCRIPTION",

    // Clear user subscriptions
    CLEAR_USER_SUBSCRIPTIONS: "CLEAR_USER_SUBSCRIPTIONS",
};

export default subscriptionsTypes;
